module.exports = __webpack_public_path__ + "static/media/aaha_kasto_ramro_jutta.0f336615.ogg";